module.exports = __webpack_public_path__ + "img/scientific-degrees.dc695489.svg";